import { render, staticRenderFns } from "./Chem2OA3_LabPerformanceTask.vue?vue&type=template&id=2ff580c5&scoped=true&"
import script from "./Chem2OA3_LabPerformanceTask.vue?vue&type=script&lang=ts&"
export * from "./Chem2OA3_LabPerformanceTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff580c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VSimpleTable})
